import TIM from "tim-js-sdk";
import TIMUploadPlugin from "tim-upload-plugin";
const TimMessage = class TimMessage {
  tim = null;
  pageThis = null;
  userTimId = "";
  userTimSign = "";
  constructor(_that) {
    this.pageThis = _that;
    this.initTim();
  }
  initTim() {
    this.tim = TIM.create({
      SDKAppID: 1600045975
    });
    this.tim.registerPlugin({
      "tim-upload-plugin": TIMUploadPlugin
    });
  }

  getTim() {
    return this.tim;
  }

  getTIM() {
    return TIM;
  }
  getTim() {
    return this.tim;
  }
  //登录腾讯云Tim
  loginTim(userTimId, userTimSign) {
    this.userTimId = userTimId;
    this.userTimSign = userTimSign;
    return new Promise((resolve, reject) => {
      this.tim
        .login({
          userID: userTimId,
          userSig: userTimSign
        })
        .then(imResponse => {
          this.bindMsgListion();
          this.tim.on(TIM.EVENT.SDK_READY, e => {
            console.log("登录成功", e);
            this.getGroupList();
            resolve(imResponse);
          });
        })
        .catch(imError => {
          reject(imError);
        });
    });
  }

  // 入群（直播聊天室推荐 AVChatRoom）
  joinGroup(groupId) {
    return this.tim.joinGroup({ groupID: groupId }).catch(err => {
      // 已在群内报错可忽略
      if (err && err.code === 10025) {
        console.log("已在群内，无需重复加入");
        return Promise.resolve();
      }
      // 群组不存在错误（10010）
      if (err && err.code === 10010) {
        console.error("群组不存在，错误码:", err.code, "群组ID:", groupId);
        console.error("群组不存在详情:", err.message || err);
        return Promise.reject({ ...err, isGroupNotExist: true });
      }
      // 其他错误
      console.warn("joinGroup error:", err);
      return Promise.reject(err);
    });
  }

  // 发送自定义消息
  // conversationType 默认群聊（直播控制台在用）；一对一会话必须显式传 CONV_C2C，
  // 否则腾讯按群 ID 找不到群，返回 10015 invalid group id，消息根本发不出去。
  sendCustomMessage(groupid, data, businessID, describe = "", conversationType = TIM.TYPES.CONV_GROUP) {
    let sendData = { businessID, list: data };
    console.log(sendData, "发送自定义消息");
    let message = this.tim.createCustomMessage({
      to: groupid,
      conversationType,
      payload: {
        data: JSON.stringify(sendData),
        description: describe
      }
    });
    // 2. 发送消息
    let promise = this.tim.sendMessage(message);
    return promise;
  }
  //发送文本消息（群聊）
  sendTextMessage(groupid, content, conversationType = TIM.TYPES.CONV_GROUP) {
    console.log(groupid, content, "发送文本消息");
    let message = this.tim.createTextMessage({
      to: groupid + "",
      conversationType,
      payload: {
        text: content
      }
      // 不要打开 needReadReceipt。已读回执要旗舰版套餐，本账号没买：
      // 对端一进会话页就会收到 7013，TUIKit 弹「已读回执是旗舰版功能」的购买提示，
      // 英文 locale 下那段文案里找不到锚点、setSpan(-1) 直接 IndexOutOfBounds 闪退
      // （集成测试 F-0 实测：打开有未读客服消息的会话页，气泡出来约 0.2s 后崩）。
      // 回执本来也没生效过，去掉不损失任何功能。
    });
    // 2. 发送消息
    let promise = this.tim.sendMessage(message);
    return promise;
  }
  //发送图片消息（群聊）
  sendImageMessage(groupid, viewId, conversationType = TIM.TYPES.CONV_GROUP) {
    let message = this.tim.createImageMessage({
      to: groupid,
      conversationType,
      payload: {
        file: document.getElementById(viewId)
      }
    });
    // 2. 发送消息
    let promise = this.tim.sendMessage(message);
    return promise;
  }
  getGroupList() {
    let promise = this.tim.getGroupList();
    promise
      .then(function(imResponse) {
        console.log(imResponse.data.groupList); // 群组列表
      })
      .catch(function(imError) {
        console.warn("getGroupList error:", imError); // 获取群组列表失败的相关信息
      });
  }

  // 获取群组在线成员数
  getGroupOnlineMemberCount(groupId) {
    return new Promise((resolve, reject) => {
      this.tim
        .getGroupOnlineMemberCount({ groupID: groupId })
        .then(imResponse => {
          resolve(imResponse.data.memberCount || 0);
        })
        .catch(imError => {
          // 群组不存在错误（10010）
          if (imError && imError.code === 10010) {
            console.error(
              "获取群组在线成员数失败：群组不存在，错误码:",
              imError.code,
              "群组ID:",
              groupId
            );
            console.error("群组不存在详情:", imError.message || imError);
          } else {
            console.warn("getGroupOnlineMemberCount error:", imError);
          }
          reject(imError);
        });
    });
  }

  // 接收消息
  bindMsgListion() {
    // ⚠️ 这段原来写在 loginTim 的 `return new Promise(...)` **之后**，永远执行不到（死代码），
    //    所以断网/重连一直没有任何处理：SDK 重连成功后会自己补推消息，但期间掉的那几条
    //    要靠上层再拉一次才补得回来。挪到这里（每次登录成功后绑定）并接上回调。
    this.tim.on(TIM.EVENT.NET_STATE_CHANGE, event => {
      const state = event && event.data && event.data.state;
      console.log('IM 网络状态', state);
      if (state === TIM.TYPES.NET_STATE_CONNECTED && this.pageThis && this.pageThis.onImReconnected) {
        this.pageThis.onImReconnected();
      }
    });
    this.tim.on(TIM.EVENT.MESSAGE_RECEIVED, e => {
      let list = e.data || [];
      // let { currentUser } = this.pageThis;
      list.forEach(item => {
        // if (item.to === currentUser.userId) {
        this.pageThis.onMessageReceived(item);
        console.log(item, "接收消息");
        // }
      });
    });
    this.tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, event => {
      this.pageThis.onConversationListUpdated(event.data);
    });
  }

  // 解绑监听并注销
  async cleanup() {
    try {
      this.tim.off(TIM.EVENT.MESSAGE_RECEIVED);
      this.tim.off(TIM.EVENT.CONVERSATION_LIST_UPDATED);
    } catch (e) {}
    try {
      await this.tim.logout();
    } catch (e) {}
    try {
      this.tim.destroy();
    } catch (e) {}
  }
};
// 会话类型常量。让调用方从这里取，而不是各自 import 一遍 tim-js-sdk。
export const CONV_C2C = TIM.TYPES.CONV_C2C;
export const CONV_GROUP = TIM.TYPES.CONV_GROUP;

export default TimMessage;
